import { NewShowJobs } from "../new-show-jobs/newShowJobs";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchJobs } from "../../../store/thunks/jobs";
import { setFavourite } from "../../../store/actions/favourite-actions";
import {
  addFilter,
  removeFilter,
  clearFilters,
  removeFromFilters,
  addToFilters,
} from "../../../store/actions/filter-actions";
import { fetchSingleJob } from "../../../store/thunks/single-job";
import { withRouter } from "react-router-dom";
import { paths } from "../../../constants/paths";

const getRecruiterJobs = (jobs) => {
  return jobs.filter((job) => {
    const title = job.title.toLowerCase();
    return (
      title.indexOf("recruiter") >= 0 ||
      title.indexOf("talent") >= 0 ||
      title.indexOf("recruiting") >= 0 ||
      title.indexOf("sourcer") >= 0
    );
  });
};

const mapStateToProps = (state) => {
  return {
    canonical: `https://justremote.co${paths.recruiter_jobs}`,
    category: "recruiter",
    meta: state.jobsState.meta,
    jobs: getRecruiterJobs(state.jobsState.entity.all),
    filters: state.filterState.manager.filters,
    filtersApplied: state.filterState.manager.filtersApplied,
    job: state.singleJobState.manager,
    favourited: state.favouriteState.favourites,
    pageTitle: `Remote Recruiter Jobs - JustRemote`,
    pageDesc:
      "Remote Recruiter Jobs from around the globe. Remote jobs added daily so make sure to visit and favourite the best jobs for you.",
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchJobs: bindActionCreators(fetchJobs, dispatch),
    fetchSingleJob: bindActionCreators(fetchSingleJob, dispatch),
    handleFavouriteClick(job) {
      dispatch(setFavourite(job));
    },
    addFilter(filter) {
      dispatch(addFilter(filter));
    },
    removeFilter(filter) {
      dispatch(removeFilter(filter));
    },
    clearFilters(category) {
      dispatch(clearFilters(category));
    },
    removeFromFilters(filter) {
      dispatch(removeFromFilters(filter));
    },
    addToFilters(filter) {
      dispatch(addToFilters(filter));
    },
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NewShowJobs)
);
